import { InquiryProvider } from "../../components/Inquiary/context/InquiryContext"
import InquiryList from "../../components/Inquiary/inquirylist"

export default function InqauryPage  () {
  return(
    <InquiryProvider>
    <InquiryList/>
    </InquiryProvider>
  )
}